import { render, staticRenderFns } from "./LegalPersonsPartner.vue?vue&type=template&id=753005dc&scoped=true&"
import script from "./LegalPersonsPartner.vue?vue&type=script&lang=js&"
export * from "./LegalPersonsPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753005dc",
  null
  
)

export default component.exports